import type { ChatMessageListResponsePageAllOf } from './chatMessageListResponsePageAllOf';
import type { ChatMessageListResponsePageAllOfThree } from './chatMessageListResponsePageAllOfThree';

export type ChatMessageListResponsePage = ChatMessageListResponsePageAllOf & ChatMessageListResponsePageAllOfThree;
